import { makeStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    background: "rgba(0, 0, 0, 0.5)",
  },
  paper: {
    borderRadius: 12,
    width: 460,
    maxWidth: "90vw",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  unpaidChip: {
    backgroundColor: fade(theme.palette.error.main, 0.12),
    color: theme.palette.error.main,
    borderRadius: 16,
    fontWeight: 700,
  },
  unpaidChipIcon: {
    color: `${theme.palette.error.main} !important`,
  },
  message: {
    marginTop: theme.spacing(1),
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
